module.exports = __webpack_public_path__ + "img/package-1.9cb2682d.png";